type Notice = {
  message: string;
  stack?: string;
};

const isBrowserExtensionError = (notice: Notice): boolean => {
  const stack = notice.stack ?? '';
  return (
    stack.includes('chrome-extension://') ||
    stack.includes('moz-extension://') ||
    stack.includes('safari-web-extension://')
  );
};

// return false if you don't want the error to be reported
export const filterHoneybadgerNotices = (notice: Notice | undefined): boolean => {
  if (!notice) return true;

  if (isBrowserExtensionError(notice)) return false;

  return (
    !notice?.message?.includes('Failed to load https://www.googletagmanager.com/gtag/js') &&
    !notice?.message?.includes('Promise.withResolvers is not a function')
  );
};
